var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout-card", {
    staticClass: "card-invoice_staff",
    attrs: {
      isCustomizable: _vm.settings.isCustomizable,
      loading: _vm.loading,
      error: _vm.error
    },
    on: {
      "edit-card": _vm.toggleSettingsForm,
      "hide-card": function($event) {
        return _vm.$emit("hide-card", _vm.type)
      },
      "refresh-card": function($event) {
        return _vm.fetchCard(_vm.type, {}, true)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [_vm._v("\n        " + _vm._s(_vm.name) + "\n    ")]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function() {
          return [
            _vm.settings.canCreate
              ? _c("CompassIconButton", {
                  attrs: { icon: "plus" },
                  on: { click: _vm.addAction }
                })
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("template-kpi-card", {
              attrs: { data: { stats: _vm.cardData, labels: _vm.labels } }
            }),
            _vm._v(" "),
            _c(
              "portal",
              { attrs: { to: "dashboardSettingsForm" } },
              [
                _vm.showSettingsForm
                  ? _c("card-setting-overlay", {
                      attrs: {
                        formName: _vm.settingsFormName,
                        cardCustomSettings: _vm.customSettings,
                        cardName: _vm.type
                      },
                      on: {
                        fetched: _vm.fetchCard,
                        "close-form": _vm.toggleSettingsForm,
                        "custom-settings-saved": function($event) {
                          return _vm.fetchCard(_vm.type, {}, true)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("fiscal-year-footer", {
              attrs: { fiscalYearTimestamp: _vm.fiscalYear }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }